import { render, staticRenderFns } from "./WaterConsumption.vue?vue&type=template&id=f5b62d94&scoped=true&"
import script from "./WaterConsumption.vue?vue&type=script&lang=js&"
export * from "./WaterConsumption.vue?vue&type=script&lang=js&"
import style0 from "./WaterConsumption.vue?vue&type=style&index=0&id=f5b62d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b62d94",
  null
  
)

export default component.exports